import { StateInterface } from "./state";
import { OrganisationModel, PrivatePersonModel } from "../models";
import { FileEntryModel } from "../models/fileEntry";

export default {
  currentOrganisation(state: StateInterface): OrganisationModel {
    return state.organisation;
  },
  currentPrivatePerson(state: StateInterface): PrivatePersonModel {
    return state.privatePerson;
  },
  fileEntries(state: StateInterface): FileEntryModel[] {
    return state.fileEntries;
  }
};
